module.exports = __webpack_public_path__ + "static/lisa-da468394eeeaf752eafc91734b271c15.jpg";